"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const next_components_icon_label_n_1 = __importDefault(require("@gerenciatd/next.components.icon-label-n"));
const next_utils_common_1 = require("@gerenciatd/next.utils.common");
const next_components_custom_link_1 = __importDefault(require("@gerenciatd/next.components.custom-link"));
const next_app_controller_reducers_sagas_modals_reducer_1 = require("@gerenciatd/next.app-controller.reducers-sagas.modals-reducer");
const utils_1 = require("../../ModalsContent/utils");
const utils_2 = require("./utils");
const constants_1 = require("../../constants");
/*
1)
  DEFAULT && !logado: =>  se oculta (a partir del limite) bajando
                      => se muestra cuando subes apartir de ese limite

2) (Sentido común)
  DEFAULT && logado:
  MMENU  =>> nunca se oculta te acompaña
 LOGADO: te acompaña y se ve siempre
 NO LOGADO:
*/
class ActionBottomBar extends react_1.Component {
    constructor(props) {
        super(props);
        this.checkAllowFadding = () => {
            let res = false;
            const { fixedMenu } = this.props;
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            if (!isSafari && fixedMenu === constants_1.MMENU_FIXED) {
                res = true;
            }
            return res;
        };
        this.state = {
            fade: false,
            mounted: false,
            allowFadding: -1,
        };
    }
    componentDidMount() {
        const { mounted, allowFadding } = this.state;
        if (!mounted && allowFadding === -1) {
            this.setState({
                mounted: true,
                allowFadding: this.checkAllowFadding(),
            });
        }
    }
    componentDidUpdate() {
        const { fade } = this.state;
        const { lastScrollY, fixedMenu, userType } = this.props;
        // 1) caso positivo
        if (!fade &&
            fixedMenu === constants_1.DEFAULT_FIXED &&
            !userType &&
            lastScrollY >= constants_1.LIMIT_FOR_ACTION_BOTTOM_BAR) {
            this.setState({
                fade: true,
            });
        }
        // 1) caso negativo
        if (fade &&
            fixedMenu === constants_1.DEFAULT_FIXED &&
            !userType &&
            lastScrollY < constants_1.LIMIT_FOR_ACTION_BOTTOM_BAR) {
            this.setState({
                fade: false,
            });
        }
    }
    render() {
        const { allowFadding, fade } = this.state;
        let { menu } = this.props;
        let moreOptions = null;
        const { isGestor, segment, userType, userSegment, modalProps, isPriority, actionBarIdSelected, scrollMovement, addModal, } = this.props;
        if (!menu || !Array.isArray(menu)) {
            return null;
        }
        if (userType) {
            ({ menu, moreOptions } = (0, utils_2.getReadyForUser)(menu, userType, segment, userSegment));
        }
        if (!menu) {
            return null;
        }
        const movementCss = allowFadding && scrollMovement ? ` scroll-${scrollMovement}` : '';
        if (fade) {
            return null;
        }
        return (react_1.default.createElement("div", { className: `ActionBottomBar${movementCss}` },
            react_1.default.createElement("div", { className: "ActionBottomBarContainer" }, menu.map((item) => {
                const { taggingInfo: itemTaggingInfo, svgId, name, link, titleBarId, } = item;
                let onClick = null;
                if (item.action && item.action.id && !link) {
                    // le paso de propiedades el moreOptions
                    const props2send = {
                        segment,
                        isPriority,
                    };
                    if (moreOptions && Array.isArray(moreOptions)) {
                        props2send.options = [...moreOptions];
                    }
                    onClick = () => {
                        (0, utils_1.handleModal)(item.action.id, modalProps, props2send, addModal);
                    };
                }
                const { iconColor, labelColor, kind, isSelected } = (0, utils_2.calculateIconState)(segment, titleBarId, actionBarIdSelected, isPriority, isGestor);
                return (react_1.default.createElement(next_components_custom_link_1.default, { href: link, key: `${svgId}-${name}`, onClick: onClick, component: onClick ? 'button' : 'a', title: name, ariaLabel: name, taggingInfo: Object.assign(Object.assign({}, itemTaggingInfo), { componentVariation: userType || '' }), className: `itemABB ${name ? (0, next_utils_common_1.normalizeString)(name) : ''} ${isSelected ? ' selected' : ''}${isPriority && !isGestor ? ` ${constants_1.PRIORITY}` : ''}`, forceExternal: true },
                    react_1.default.createElement(next_components_icon_label_n_1.default, { id: svgId, iconColor: iconColor, iconSize: 28, labelSize: 10, label: name, kind: kind, labelColor: labelColor, segment: segment })));
            }))));
    }
}
const mapDispatchToProps = (dispatch) => ({
    addModal: (data) => dispatch(next_app_controller_reducers_sagas_modals_reducer_1.actions.addModal(data)),
});
exports.default = (0, react_redux_1.connect)(null, mapDispatchToProps)(ActionBottomBar);
//# sourceMappingURL=index.js.map